const FEED = [
  {
    date: '今日 · 09-09',
    items: [
      { time: '16:42', tag: '深扒', tagTone: 'verm', title: '某MCN前员工晒出排班表，称直播间"虚假在线"是常态', summary: '配了三个月打卡与直播后台截图对比，正在补齐自动刷场次那段的图解。', ext: '补图解中', views: '1.9w' },
      { time: '15:18', tag: '快讯', tagTone: 'tan', title: '涉事品牌二版声明上线，删除了首版中的"同事误会"表述', summary: '两版声明逐字差异已标红，可直达帖子图解对照看。', ext: '已图解', views: '8.6k' },
      { time: '13:55', tag: '长文', tagTone: 'gold', title: '连麦对质完整录屏流出，长文版连夜补了 3000 字', summary: '新增第 7~10 分钟对话逐句转写与前后时间差对照。', ext: '长文第14期', views: '3.2w' },
      { time: '11:26', tag: '深扒', tagTone: 'verm', title: '被指"口头画饼"的合伙人自述帖更新，评论区吵成两派', summary: '楼主补充了一版未删减的分成沟通截图，讨论版已开专楼。', ext: '专楼热议', views: '5.4k' }
    ]
  },
  {
    date: '昨日 · 09-08',
    items: [
      { time: '22:07', tag: '图解', tagTone: 'gold', title: '图解：一份"已读不回"的报价单，藏着三次压价套路', summary: '截图红线逐条标注，把话术拆成 6 步，适合不想看长文的用户直接滑图。', ext: '6 图图解', views: '7.1k' },
      { time: '18:30', tag: '合集', tagTone: 'tan', title: '"突然停更"案例再收一个样本，合集增至 14 例', summary: '本次新增直播切片三连，已归入"停更时间线"合集分节。', ext: '合集更新', views: '3.9k' },
      { time: '14:02', tag: '长文', tagTone: 'gold', title: '万字长文系列《背刺的一年》更新第三部：分账截图阶段', summary: '以日期为轴重排所有打款记录，图多文长，建议配合图解食用。', ext: '图解同发', views: '1.6w' }
    ]
  }
];

const HOT = [
  { rank: 1, title: '两版声明连夜改口，谁在替谁说话', heat: '42.3w', up: true },
  { rank: 2, title: '连麦对质全录屏逐句时间线（含删减段）', heat: '38.1w', up: true },
  { rank: 3, title: '"停更"半个月后突然回归，配图细节对不上', heat: '27.8w', up: true },
  { rank: 4, title: '合伙分成聊天记录：承诺写在口头，黑纸在哪', heat: '19.5w', up: false },
  { rank: 5, title: '一份晒单暴露的自评小号，账号已被清空', heat: '12.4w', up: true },
  { rank: 6, title: '前员工集体站队，评论区出现同一句文案', heat: '9.8w', up: false }
];

export default function QuickFeed() {
  return (
    <section id="feed" className="bg-band">
      <div className="mx-auto max-w-[1360px] px-4 py-10 md:px-6 md:py-14">
        <div className="grid gap-8 lg:grid-cols-3">
          {/* 快讯时间线流 */}
          <div className="lg:col-span-2">
            <div className="mb-5 flex flex-wrap items-end justify-between gap-3 border-b-2 border-ink pb-3">
              <div className="flex items-center gap-2">
                <i className="ri-live-line text-xl text-verm" />
                <h2 className="font-display text-xl font-black md:text-2xl">最新快讯时间线</h2>
                <span className="mb-0.5 rounded-full bg-verm px-2 py-0.5 text-[11px] font-bold text-paper2">滚动更新</span>
              </div>
              <a href="#deep-read" className="flex items-center gap-1 text-sm text-ink/60 hover:text-verm">
                全部动态 <i className="ri-arrow-right-line" />
              </a>
            </div>

            <div className="space-y-7">
              {FEED.map((day) => (
                <div key={day.date}>
                  <div className="mb-3 flex items-center gap-2">
                    <span className="bg-ink px-2 py-1 text-xs font-semibold text-paper2">{day.date}</span>
                    <span className="h-px flex-1 bg-line" />
                  </div>
                  <div className="relative ml-2 space-y-5 border-l-2 border-line/80 pl-6">
                    {day.items.map((it, i) => (
                      <article key={i} className="group relative">
                        <span className="absolute -left-[31px] top-1.5 h-3 w-3 rounded-full border-2 border-paper bg-verm" />
                        <span className="absolute -left-[36px] top-1 text-[10px] font-semibold text-ink/50">{it.time}</span>
                        <div className="rounded-lg border border-line/70 bg-paper2 p-4 transition-colors hover:border-verm/40 hover:bg-verm-wash md:p-5">
                          <div className="flex flex-wrap items-center gap-2">
                            <span
                              className={`px-1.5 py-0.5 text-[11px] font-semibold ${
                                it.tagTone === 'verm'
                                  ? 'bg-verm text-paper2'
                                  : it.tagTone === 'gold'
                                  ? 'bg-gold text-paper2'
                                  : 'bg-tan text-paper2'
                              }`}
                            >
                              {it.tag}
                            </span>
                            <span className="text-xs text-ink/40">09 月 · {it.time}</span>
                            {it.ext && (
                              <span className="ml-auto flex items-center gap-1 rounded-full bg-gold-soft px-2 py-0.5 text-[11px] text-gold">
                                <i className="ri-file-list-3-line" />
                                {it.ext}
                              </span>
                            )}
                          </div>
                          <h3 className="mt-2.5 text-[15px] font-bold leading-snug group-hover:text-verm md:text-base">
                            <a href="#deep-read" className="hover:text-verm">
                              {it.title}
                            </a>
                          </h3>
                          <p className="mt-1.5 text-sm leading-relaxed text-ink/60">{it.summary}</p>
                          <div className="mt-3 flex items-center justify-between text-xs text-ink/45">
                            <span className="flex items-center gap-2">
                              <span className="flex items-center gap-1"><i className="ri-eye-line" /> {it.views}</span>
                              <span className="hidden items-center gap-1 sm:flex"><i className="ri-arrow-right-up-line" /> 整理自公开讨论</span>
                            </span>
                            <a href="#deep-read" className="flex items-center gap-0.5 whitespace-nowrap font-semibold text-verm hover:opacity-75">
                              进详情 <i className="ri-arrow-right-up-line" />
                            </a>
                          </div>
                        </div>
                      </article>
                    ))}
                  </div>
                </div>
              ))}
              <a
                href="#feed"
                className="mx-auto flex w-fit items-center gap-1 whitespace-nowrap text-sm font-semibold text-ink/60 hover:text-verm"
              >
                加载更早快讯 <i className="ri-loader-3-line" />
              </a>
            </div>
          </div>

          {/* 右侧：实时热榜 + 正在热议 */}
          <aside className="space-y-6">
            <div className="border border-line bg-paper2">
              <div className="flex items-center justify-between border-b border-line px-4 py-3">
                <div className="flex items-center gap-2">
                  <i className="ri-fire-fill text-xl text-verm" />
                  <h3 className="font-display text-lg font-black">实时热榜</h3>
                </div>
                <span className="rounded-full bg-verm-soft px-2 py-0.5 text-[11px] font-semibold text-verm">每 5 分钟刷新</span>
              </div>
              <ol className="divide-y divide-line/60 px-4">
                {HOT.map((h) => (
                  <li key={h.rank}>
                    <a href="#deep-read" className="group flex items-start gap-3 py-3">
                      <span
                        className={`flex h-6 w-6 shrink-0 items-center justify-center text-sm font-black ${
                          h.rank <= 3 ? 'bg-verm text-paper2' : 'bg-band text-ink/55'
                        }`}
                      >
                        {h.rank}
                      </span>
                      <span className="min-w-0 flex-1">
                        <span className="block text-sm font-medium leading-snug group-hover:text-verm">{h.title}</span>
                        <span className="mt-1 flex items-center gap-1.5 text-xs text-ink/45">
                          <span className="flex items-center gap-0.5 text-verm">
                            <i className={`${h.up ? 'ri-arrow-up-line' : 'ri-arrow-down-line'} text-[11px]`} />
                            {h.heat}
                          </span>
                          热议中
                        </span>
                      </span>
                    </a>
                  </li>
                ))}
              </ol>
              <a href="#discussion" className="flex items-center justify-center gap-1 border-t border-line px-4 py-2.5 text-sm font-semibold text-verm hover:bg-verm-soft">
                进入讨论版围观 <i className="ri-arrow-right-s-line" />
              </a>
            </div>

            {/* 正在热议投票（静态展示） */}
            <div className="border border-gold/40 bg-gold-soft/50 p-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <i className="ri-question-line text-lg text-gold" />
                  <h3 className="font-display text-base font-black">本日站队投票</h3>
                </div>
                <span className="text-xs text-ink/45">2.4k 人已投</span>
              </div>
              <p className="mt-2 text-sm text-ink/75">连麦对质后，你觉得二版声明算"补锅"还是"实锤"？</p>
              <div className="mt-4 space-y-3">
                {[
                  { txt: '算补锅，越描越黑', pct: 58 },
                  { txt: '实锤了，细节对不上', pct: 27 },
                  { txt: '说不清，蹲后续图解', pct: 15 }
                ].map((o) => (
                  <button
                    key={o.txt}
                    type="button"
                    className="relative block w-full overflow-hidden border border-line bg-paper2 px-3 py-2.5 text-left text-sm hover:border-gold"
                  >
                    <span className="absolute inset-y-0 left-0 bg-gold-soft/80" style={{ width: `${o.pct}%` }} />
                    <span className="relative flex items-center justify-between gap-2">
                      <span className="font-medium text-ink/85">{o.txt}</span>
                      <span className="font-black text-verm">{o.pct}%</span>
                    </span>
                  </button>
                ))}
              </div>
              <p className="mt-3 text-center text-[11px] text-ink/40">投票结果仅作氛围展示，非正式统计</p>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}